export default __webpack_public_path__ + "static/media/plata.2ef93243.png";